/**
 * IMPORTANT!
 *
 * Sorting groups for isometry sorting solver.
 * Order of the items actually matter, that's how
 * the items will appear.
 */
export var IdIsoSortingGroup;
(function (IdIsoSortingGroup) {
    IdIsoSortingGroup[IdIsoSortingGroup["None"] = 0] = "None";
    IdIsoSortingGroup[IdIsoSortingGroup["Buildings"] = 1] = "Buildings";
    IdIsoSortingGroup[IdIsoSortingGroup["BuildingPlacement"] = 2] = "BuildingPlacement";
})(IdIsoSortingGroup || (IdIsoSortingGroup = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/iso/IdIsoSortingGroup.ts
// module id = 578
// module chunks = 3